<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
};
</script>
<style>
#app {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
}
</style>
